import { ConfirmAddToCart } from "@redotech/redo-agents-cards/support-agents/confirm-add-to-cart";
import * as z from "zod";
import { literal } from "zod";
import { ContentType } from "../../conversation";
import {
  AutoGeneratedFieldsSchema,
  BaseToolCallMessageSchema,
} from "../message-parser-utils";

const CartMessageSchema = BaseToolCallMessageSchema.extend({
  contentType: literal(ContentType.CART_ITEMS),
  structuredContent: ConfirmAddToCart.optional(),
});

export const CartMessageDbParser = CartMessageSchema.merge(
  AutoGeneratedFieldsSchema,
);
export type CartMessageType = z.infer<typeof CartMessageDbParser>;
